<footer id="remitos-footer">
      <span class="left">
         <img src="/assets/images/GM_Brandmark.png" alt="general motors"/>
      </span>
      <span class="center">
          GM Confidential
      </span>
      <span class="right">
          &copy; General Motors {{currentYear}}. All Rights Reserved.
      </span>
</footer>
